import { useMutation, useQuery } from 'react-query';
import { SprintService } from '@api/SprintService';
import { onDefaultError } from '../helpers/commonHelpers';
// Records
const useListSprint = ([ id, page_no, searchText, paymentStatusTypesID, profitibilityStatusID], onSuccess, onError = onDefaultError ) => {
  return useQuery(
    ['sprint-list', id, page_no, searchText, paymentStatusTypesID, profitibilityStatusID],
    () => SprintService.listAllSprint({ id, page_no, searchText, paymentStatusTypesID, profitibilityStatusID }),
    {
      onSuccess,
      keepPreviousData: true,
      onError
    }
  );
};
// Remove
const useDeleteSprint = () => {
  const deleteSprint = async (projectId, id) => {
    return await SprintService.deleteSprint(projectId, id);
  };
  return { deleteSprint };
};
// Create
const useAddSprint = (onSuccess, onError = onDefaultError) => {
  return useMutation(SprintService.addSprint, {
    onSuccess,
    onError
  })
}
// Update
const useUpdateSprint = (onSuccess, onError = onDefaultError) => {
  return useMutation(SprintService.updateSprint, {
    onSuccess,
    onError
  })
}
// Get Details
const useEditSprint = (projectId, id, onSuccess, onError = onDefaultError) => {
  return useQuery('sprint-edit', () => SprintService.viewSprint(projectId, id), {
    onSuccess,
    onError
  });
};
// Get Sprint Status Type
const useGetSprintStatusTypes = (onSuccess, onError = onDefaultError) => {
  return useQuery("sprint-status-type" , SprintService.sprintStatusTypes, {
    onSuccess,
    onError
  });
};

const useGetPaymentStatusTypes = (onSuccess, onError = onDefaultError) => {
  return useQuery("payment-status-type" , SprintService.paymentStatusTypes, {
    onSuccess,
    onError
  });
};

const useGetProfitabilityStatusTypes = (onSuccess, onError = onDefaultError) => {
  return useQuery("profitability-status-type" , SprintService.profitabilityStatusTypes, {
    onSuccess,
    onError
  });
};
const useCompleteSprint = (onSuccess, onError = onDefaultError) => {
   return useMutation(SprintService.sprintStatusUpdate, {
    onSuccess,
    onError
  });
};

const useGetDeliveryManagerProjects = (
  { type, onSuccess, onError } = {}
) => {

  return useQuery(
    ["project-delivery-manager", type],
    () => SprintService.deliveryManagerProjects(type ? { type } : undefined),
    {
      onSuccess,
      onError: onError ?? onDefaultError,
    }
  );
};

export {
  useDeleteSprint,
  useListSprint,
  useAddSprint,
  useUpdateSprint,
  useEditSprint,
  useGetSprintStatusTypes,
  useGetPaymentStatusTypes,
  useGetProfitabilityStatusTypes,
  useGetDeliveryManagerProjects,
  useCompleteSprint
};
